<script lang="ts">
  import Link from "svelte-link";
  import { Card, Image, Row } from "sveltestrap";
  import { productDetailsData } from "../../../../Data/Ecommerce/ProductDetails/ProductDetails";
  import {grid,classId,modalIsopen,viewModalProduct,selectData,selectValue, searchResult,category,colors} from "../../../../store"
  import { href } from "../../../../utils/Constant/Constant";
  import ProductModal from "./ProductModal.svelte";
  import {handleCart} from "../../../../Data/Ecommerce/Cartdata"
  import ProductPrice from "./ProductPrice.svelte";
  let imgPath:string = "/assets/images";
  let newId:number;
  let qty:number = 1
  // for modal open and close
  const modalHandle = (id:number) => {
    newId = productDetailsData.findIndex((obj) => obj.id === id)
    viewModalProduct.update(value => value = productDetailsData[newId]) 
    if(id === productDetailsData[newId].id){
      modalIsopen.update((value) => (value = !value));
    }
  };
  let setSelectData:any 
  selectData.subscribe((value)=>{
    setSelectData = value
  })
  // for grid class
  let setgrid:boolean;
  grid.subscribe((value) => {
    setgrid = value;
  });
  let setclassId:number;
  if(setgrid === false) {
    classId.subscribe((value) => {
      setclassId = value;
    });
  } else {
    setclassId = 3;
  }
  let setSearchResult:any
  searchResult.subscribe((value)=>{
      setSearchResult = value
  })
  let setCategory
  category.subscribe((value)=>{
    setCategory = value
  })
  let setSelectValue
  $: selectValue.subscribe((value)=>{
    setSelectValue = value
  })
  let setColors
  colors.subscribe((value)=>{
    setColors = value
  })
  let data
  $: if(setSearchResult.length > 0){
      data = setSearchResult
    }else if(setCategory.length > 0){
      data = productDetailsData.filter((data) => data.category === setCategory)
    }else if(setSelectValue > 100){
      data = productDetailsData.filter((data) => (data.price < setSelectValue))
    }else if(setColors.length > 0){
      data = productDetailsData.filter((data)=> data.colors.indexOf(setColors) != -1 )
    }else{
      data = productDetailsData
    }
</script> 
<Row>
  {#each data as productItem}
    <div class="{setgrid ? "col-xl-12" : `col-xl-${setclassId} col-sm-${setclassId}`}">
      <Card>
        <div class="product-box">
          <div class="product-img">
            {#if productItem.status !== "none"}
              <div class="ribbon {productItem.color}">{productItem.status}</div>
            {/if}
            <Image fluid src="{imgPath}/{productItem.img}" />
            <div class="product-hover">
              <ul>
                <li>
                  <Link href="/ecommerce/cart" on:click={()=> handleCart(productItem,qty)} >
                    <i class="icon-shopping-cart"/>
                  </Link>
                </li>
                <li>
                  <Link href={href} on:click={() => modalHandle(productItem.id)}>
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <i class="icon-eye"/>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <ProductModal />
          <ProductPrice productItem={productItem}/>
        </div>
      </Card>
    </div>
  {/each}
</Row>
  